/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('PlanningPosCtrl', ["$log", "$scope", "$document", "$http", "$rootScope", "$routeParams", "$window", "$location", "$timeout", "$dialog", "HumanResourceData",
    "PlanningPosView", "DaySrv", "PlanningTableView", "SiteData", "DayData", "UserActionManager", "usSpinnerService", "MessageSrv", "LanguageManager", "gettextCatalog",
    "AppData", "AppSrv", "AppAttribute", "LaunchDarklyFeatureFlagData", "LaunchDarklyFeatureFlagList", "App", "UserActionSrv", "CustomerData", "BookingData", "BookingView",
    "Booking", "DayHrData", "TypeOfModification", "BookingCreator", "BookingService", "MonitoringApplication", "MonitoringSrv", "MonitoringHealthState", "MeasureStore",
    "Decorators", "TimeMeasures", "moment", "SaleData", "Constants", "Auth", "StoreAppCode", "UserSrv", "BasicAuthRole", "Timers", "Images", "CompanyTypes",
    function ($log, $scope, $document, $http, $rootScope, $routeParams, $window, $location, $timeout, $dialog, HumanResourceData, PlanningPosView, DaySrv, PlanningTableView,
              SiteData, DayData, UserActionManager, usSpinnerService, MessageSrv, LanguageManager, gettextCatalog, AppData, AppSrv, AppAttribute,
              LaunchDarklyFeatureFlagData, LaunchDarklyFeatureFlagList, App, UserActionSrv, CustomerData, BookingData, BookingView, Booking,
              DayHrData, TypeOfModification, BookingCreator, BookingService, MonitoringApplication, MonitoringSrv, MonitoringHealthState, MeasureStore,
              Decorators, TimeMeasures, moment, SaleData, Constants, Auth, StoreAppCode, UserSrv, BasicAuthRole, Timers, Images, CompanyTypes) {
        $scope.dragOrResizeBS = null; // Manage issue with conflict between click + drag + resize
        $scope.AGENDA_APP_CODE = "agenda";
        $scope.HIGH_CONTRAST_APP_ATTRIBUTE_CODE = "highContrast";
        let timers = [];

        //Define domain data :
        $scope.dd = {
            view: { //Replaced by PlanningView after Loading
                humanResourcesView: [],
                pTView: {
                    loading: true
                }
            },
            bookingStatusImage: Images.saleStatus,
            bookingCreators: BookingCreator,
            basicAuthRole: BasicAuthRole,
            userActionToCancel: null,//next action than can be canceled
            userActionToCancelDisplay: false,
            userActionToCancelDisplayTimeout: null,
            userActionToRedo: null,//redo
            edited: {
                customerView: null
            },//TODO MOVE CUSTOMER VARIABLES
            displaySubConf: 1,
            displayError: false,
            displayPhoneError: false,
            displayLandlineError: false,
            displayTable: false,
            displaySelectorLarge: false,
            time: null,
            subject: "toto",
            personne: "Mirella"
        };

        $scope.options = {
            customClass: function (data) {
                var date = data.date,
                    mode = data.mode;
                if (mode === 'day') {
                    var dayToCheck = new Date(date).setHours(0, 0, 0, 0);
                    var currentDay = new Date().setHours(0, 0, 0, 0);
                    if (dayToCheck === currentDay)
                        return 'currentDay';
                    else {
                        if ($scope.dd.view.pTView.plgDaysViewDisplayed) {
                            for (var i = 0; i < $scope.dd.view.pTView.plgDaysViewDisplayed.length; i++) {
                                if ($scope.dd.view.pTView.plgDaysViewDisplayed[i].display) {
                                    var dayOfDateToCheck = new Date($scope.dd.view.pTView.plgDaysViewDisplayed[i].date).setHours(0, 0, 0, 0);
                                    if (dayOfDateToCheck === dayToCheck) {
                                        return "displayed";

                                    }
                                }
                            }
                        }
                    }
                }
                var day = DayData.getById(DaySrv.getIdFromDate(date));
                if (day && !day.isOpen())
                    return 'closed'
                return '';
            },
            showWeeks: false
            //add the other options here
        };

        $scope.dateOptions = {
            'year-format': "'yy'",
            'starting-day': 1
        };

        $scope.loyaltyCardDateOptions = {
            'year-format': "'yy'",
            'starting-day': 1,
            'minDate': new Date()
        };

        const onGlobalLoadingFinishedDestroy = $rootScope.$on('onGlobalLoadingFinished', function () {
            $scope.loadViews();
        });

        //if ($scope.ad.dataLoaded)
        $scope.loadViews = function () {
            $scope.dd.view = new PlanningPosView($scope);

            let today = new Date();
            let todayIndex = today.getDay() - 1;//day of week;
            if (todayIndex === -1) {
                todayIndex = 6;
            }
            let diff = today.getDate() - todayIndex;
            let firstDayOfWeek = new Date(today.setDate(diff));//Start at monday

            $scope.dd.view.initSubViews($scope.dd.view.hasHr, false, $scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight(), firstDayOfWeek, $scope.dd.view.hasPr);
            $scope.updateTimeLineAndActivityIsPast();
            //if pos active : create a new booking
            if ($scope.ad.sDm === 'pos') {
                $scope.dd.view.posView.addSaleViewNow(null);
            }
        };

        $scope.redirectToPlanningIfPosDisabled = function () {
            if ($scope.ad.loggedUser && $scope.ad.loggedUser.company.type !== CompanyTypes.CANCELED.value && $scope.ad.sDm === Constants.APP_SUB_DOMAIN.pos) {
                if (!$scope.ad.addons.sub.posAccess) {
                    if ($scope.ad.domain === Constants.APP_DOMAIN.planningPos) {
                        $scope.goToSubDomain(Constants.APP_SUB_DOMAIN.planning);
                    } else {
                        $scope.goToDomain(Constants.APP_DOMAIN.planningPos, Constants.APP_SUB_DOMAIN.planning);
                    }
                }
            }
        };

        $scope.$watch('ad.sDm', function () {
            $scope.redirectToPlanningIfPosDisabled();
        });

        $scope.$watch('ad.dataLoaded', function (loaded) {
            if (loaded) {
                if (SiteData.defaultSite.workingPeriods.length === 0 && $scope.ad.managerMode) {
                    $scope.dd.view.pTView.loading = false;
                    $scope.goToDomain("site");
                    return;
                }

                if ($scope.ad.firstLoadingProcess) {
                    if ($rootScope.canAccessNewLoading) {
                        MeasureStore.registerStart(TimeMeasures.PLANNING_POS_GLOBAL_TIME_STARTUP);
                    } else {
                        MeasureStore.registerStart(TimeMeasures.PLANNING_POS_GLOBAL_TIME);
                    }

                    $scope.loadViews();

                    if ($rootScope.canAccessNewLoading) {
                        MeasureStore.registerEnd(TimeMeasures.PLANNING_POS_GLOBAL_TIME_STARTUP);
                        MeasureStore.registerStart(TimeMeasures.AFTER_LOADING_STARTUP_REMAINING_TIME);
                    } else {
                        MeasureStore.registerEnd(TimeMeasures.PLANNING_POS_GLOBAL_TIME);
                        MonitoringSrv.logHealth(MonitoringApplication.PROBACKOFFICE, MonitoringHealthState.OK, JSON.stringify(MeasureStore));
                    }
                } else {
                    const timer = $timeout($scope.loadViews, 100);  // Assychron load to display waiting spinner when return to planning
                    timers.push(timer);
                }
            }
        });

        $scope.$on('displayUnsavedMessageOnPlanningPosCtrl', function () {
            if ($scope.dd.view.pTView instanceof PlanningTableView) {
                $scope.dd.view.pTView.displayUnsavedChangeMessage();
            }
        });

        $scope.$on('editedBookingStatusOnPlanningPosCtrl', function () {
            let isUnsaveBooking = false;
            if ($scope.dd.view.pTView instanceof PlanningTableView && $scope.dd.view.pTView.isPlanningPosUnsavedBooking()) {
                isUnsaveBooking = true;
            }
            $scope.$emit("editedBookingStatusToAppCtrl", isUnsaveBooking);
        });

        const goToDomainCalledDestroy = $rootScope.$on('goToDomainCalled', function () {
            if ($scope.dd.view && $scope.dd.view.posView && $scope.dd.view.display) {
                if ($scope.ad.sDm === 'pos')
                    $scope.dd.view.posView.activateView();
                if ($scope.ad.sDm === 'dashboard' && $scope.dd.view.dashboardView)
                    $scope.dd.view.dashboardView.loadData();
            }
        });

        $scope.$watch('dd.view.pTView.dim.nbDays', function (newValue, oldValue) {
            if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView && oldValue !== undefined) {
                $scope.dd.view.pTView.initPlgDaysView($scope.dd.view.pTView.firstDayIndexDisplayed);
                $scope.dd.view.pTView.saveAgendaAppParameter(oldValue, null);
            }
        });

        const onNotificationActionDestroy = $rootScope.$on('onNotificationAction', function (_, objectNotification) {
            if (objectNotification && objectNotification.data && $scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.posView)//normal notifications
            {
                if (objectNotification.data.globalObjectType === "Booking")
                    $scope.dd.view.pTView.setAndDisplayEditedBookingViewFromIndex(objectNotification.data.index);
                else if (objectNotification.data.globalObjectType === "Sale")
                    $scope.dd.view.posView.setEditedSaleViewFromIndex(objectNotification.data.index);

                $scope.safeApply();
            } else if (objectNotification && objectNotification.booking && objectNotification.booking.currentVersion) {//userAction from getUserActionBooking
                if (objectNotification.booking.currentVersion.objectType === "Booking") {
                    let index = BookingData.getIndexOf(BookingData.getById(objectNotification.booking.currentVersion.id));
                    if (index !== -1) {//booking ever exist
                        let booking = BookingData.getById(objectNotification.booking.currentVersion.id);
                        booking.isDeleted = false;
                        $scope.dd.view.pTView.setAndDisplayEditedBookingViewFromIndex(BookingData.getIndexOf(booking));
                        if (objectNotification.globalType === "delete") {
                            let bookingView = $scope.dd.view.pTView.edited.bookingView;
                            bookingView.bookingIndex = -1;
                            bookingView.status = "created";
                            $scope.removeBsIndexFromDeletedBookingView(bookingView);
                        }
                    } else {//booking not exist
                        if (objectNotification.globalType === "delete") {

                            let day = DayData.getById(objectNotification.booking.currentVersion.dayId),
                                dayIndex = DayData.getIndexOf(day),
                                plgDayView = $scope.dd.view.pTView.getPlgDayViewByDayIndex(dayIndex),
                                book = new Booking(objectNotification.booking.currentVersion, null, true, true);
                            if (objectNotification.booking.currentVersion.bookingServicesDetail != null) {
                                for (let i = 0; objectNotification.booking.currentVersion.bookingServicesDetail.length > i; i++) {
                                    let bookingService = new BookingService(objectNotification.booking.currentVersion.bookingServicesDetail[i], null, true, true);
                                    book.bookingServices.push(bookingService);
                                }
                            }
                            book.loadRef();
                            book.isDeleted = false;
                            let bookingView = new BookingView(book, -1, $scope.dd.view.pTView, plgDayView, true);
                            $scope.removeBsIndexFromDeletedBookingView(bookingView);
                            bookingView.setSelectedByUserAuto();
                            if (bookingView.selectedByUser && bookingView.selectedByUser.activityView && bookingView.selectedByUser.activityView.plgDayHrView && bookingView.selectedByUser.activityView.plgDayHrView.hrView)
                                bookingView.setSelectedByUserHrView(bookingView.selectedByUser.activityView.plgDayHrView.hrView);

                            plgDayView.addBookingView(bookingView);
                            plgDayView.pTView.setEditedBookingView(bookingView);
                        }
                    }
                    $scope.dd.view.pTView.domainView.scope.goToSubDomain('planning');

                }
            }
        });

        $scope.removeBsIndexFromDeletedBookingView = function (bookingView) {
            for (let i = 0; bookingView.bookingServicesView.length > i; i++) {
                bookingView.bookingServicesView[i].actIndex = -1;
            }
        };

        const onExternalModelChangedDestroy = $rootScope.$on('onExternalModelChanged', function (_, objectModification, isNotFromAngularEvent) {
            if ($scope.dd.view) {
                if ($scope.dd.view.onExternalModelChanged !== undefined) {
                    $scope.dd.view.onExternalModelChanged(objectModification);
                } else {
                    const timer = $timeout(function () {
                        if ($scope.dd.view.onExternalModelChanged !== undefined)
                            $scope.dd.view.onExternalModelChanged(objectModification);
                    }, 5000);
                    timers.push(timer);
                }

                if (isNotFromAngularEvent !== undefined && isNotFromAngularEvent)
                    $scope.safeApply();
            }
        });

        const onChangeUserActionToCancelDestroy = $rootScope.$on('onChangeUserActionToCancel', function (_, userAction) {
            console.log("$rootScope.$on('onChangeUserActionToCancel', function(_,userAction)");
            console.log($scope.dd.userActionToCancel);
            console.log(userAction);
            if (userAction && userAction.description) {
                if (userAction.globalObjectType === 'Booking') {
                    userAction.userActionTagPrefix = 'booking_' + userAction.globalType;
                } else if (userAction.globalObjectType === 'Activity') {
                    userAction.userActionTagPrefix = 'unavailability_' + userAction.globalType;
                } else {
                    userAction.userActionTagPrefix = userAction.globalObjectType + '_' + userAction.globalType;
                }

                $scope.dd.userActionToCancelDisplay = true;

                if ($scope.dd.userActionToCancelDisplayTimeout) {
                    $timeout.cancel($scope.dd.userActionToCancelDisplayTimeout);
                }
                $scope.dd.userActionToCancelDisplayTimeout = $timeout(function () {
                    $scope.dd.userActionToCancelDisplay = false;
                }, 8000)
            }
            $scope.dd.userActionToCancel = userAction;
            $scope.dd.userActionToRedo = null;
        });

        const onChangeUserActionToRedoDestroy = $rootScope.$on('onChangeUserActionToRedo', function (_, userAction) {
            $scope.dd.userActionToRedo = userAction;//feature removed from interface
        });

        $scope.updateTimeLineAndActivityIsPast = Decorators.timeMeasureDecorator(
            function () {
                const now = new Date();
                $scope.dd.view.pTView.updateTimeLineAndActivityIsPast(now);
                const timer = $timeout($scope.updateTimeLineAndActivityIsPast, 60 * 1000);
                timers.push(timer);

                const currentTime = now.getTime();
                if ($scope.dd.time && currentTime > ($scope.dd.time + 30 * 60 * 1000)) {
                    MessageSrv.send(
                        "warning",
                        gettextCatalog.getString("Mise en veille détectée.") + "<br/>" +
                        gettextCatalog.getString("Il est recommandé de recharger l'application"),
                        false);
                }
                $scope.safeApply();
                $scope.dd.time = currentTime;
            }, TimeMeasures.TIMELINE_AND_ACTIVITY_IS_PAST
        );

        var doit;
        window.onresize = function () {
            clearTimeout(doit);
            doit = setTimeout($scope.onWindowResizeEnd, 500);
        };

        $scope.onWindowResizeEnd = function () {
            if ($scope.dd.view && $scope.dd.view.pTView && $scope.dd.view.pTView instanceof PlanningTableView) {
                $scope.dd.view.pTView.updateSize($scope.getPlanningLeft(), $scope.getPlanningTop(), $scope.getPlanningWidth(), $scope.getPlanningHeight());
                $scope.safeApply();
            }
            if ($scope.dd.view && $scope.dd.view.posView && $scope.ad.sDm === 'pos') {
                $scope.dd.view.posView.resizeBasket();
            }
        };

        $scope.safeApply = function (fn) {
            if ($scope.$root) {
                var phase = $scope.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof (fn) === 'function')) {
                        fn();
                    }
                } else {
                    $scope.$apply(fn);
                }
            } else
                $scope.$apply(fn);

        };

        $scope.getPlanningLeft = function () {
            let planningStart = 0;
            if ($scope.dd.isStandardWeek) {
                let cfgMenuWidth = angular.element('#cfg-menu').css('width');
                let posMenuWidth = angular.element('#pos-menu').css('width');
                let menuWidthStr = '';

                if (cfgMenuWidth) {
                    menuWidthStr = cfgMenuWidth;
                } else if (posMenuWidth) {
                    menuWidthStr = posMenuWidth;
                }

                if (menuWidthStr) {
                    menuWidthStr = menuWidthStr.replace("px");
                    planningStart = parseInt(menuWidthStr);
                }
            }
            return planningStart;
        };

        $scope.getPlanningTop = function () {
            return 175;// menu only + action barre  + table titles
        };

        $scope.getPlanningWidth = function () {
            let bodyWidth = $scope.getDomainWidth();

            if ($scope.dd.isStandardWeek) {
                let menuLeft = $scope.getPlanningLeft();
                if (menuLeft) {
                    bodyWidth -= menuLeft;
                }
            }

            return bodyWidth;
        };

        $scope.getPlanningHeight = function () {
            var planningHeightStr = angular.element('body').css('height');
            if (planningHeightStr == null)
                return 0;
            var planningHeight = parseInt(planningHeightStr.replace("px"))
            planningHeight -= $scope.getPlanningTop();//menu + action barre + table titles
            return planningHeight;
        };

        $scope.getDomainWidth = function () {
            var bodyWidthStr = angular.element('body').css('width');
            bodyWidthStr = bodyWidthStr.replace("px");
            var bodyWidth = parseInt(bodyWidthStr);
            return bodyWidth;
        };


        $scope.displayPlanningDatePickerF = function () {
            if ($scope.dd.view.pTView.isPlanningPosUnsavedBooking()) {
                $scope.dd.view.pTView.displayUnsavedChangeMessage();
                return;
            }

            const timer = $timeout(function () {
                $scope.dd.view.pTView.datePicker = new Date($scope.dd.view.pTView.firstDateDisplayed);
                $scope.dd.view.pTView.datePickerOpened = true;
            });
            timers.push(timer);
        };

        $scope.filterNotification = function (value, index, array) {
            return value.globalType === $scope.ad.view.notificationDisplayParameters.typeModification.id || $scope.ad.view.notificationDisplayParameters.typeModification === TypeOfModification.ALL;
        };

        $scope.listenForBackofficeApp = function (event) {
            if (event && event.data) {
                if (event.data.logout) {
                    Auth.logout();
                } else if (event.data.editedGiftItem) {
                    $scope.dd.view.posView.setEditedGiftItemView(event.data.editedGiftItem, () => {
                        $scope.navigateToNgApp({
                            name: Constants.ANGULAR_EVENTS.REFRESH,
                            value: Constants.ANGULAR_TABS.GIFT_ITEMS,
                            customerId: event.data.customerId
                        });
                    });
                } else if (event.data.editedLoyaltyCard) {
                    $scope.dd.view.posView.setEditedLoyaltyCardItemView(event.data.editedLoyaltyCard, () => {
                        $scope.navigateToNgApp({
                            name: Constants.ANGULAR_EVENTS.REFRESH,
                            value: Constants.ANGULAR_TABS.LOYALTY_CARD_ITEMS,
                            customerId: event.data.customerId
                        });
                    });
                } else if (event.data.editedCureItem) {
                    $scope.dd.view.posView.openCureItemWindow(event.data.editedCureItem, () => {
                        $scope.navigateToNgApp({
                            name: Constants.ANGULAR_EVENTS.REFRESH,
                            value: Constants.ANGULAR_TABS.CURE_ITEMS,
                            customerId: event.data.customerId
                        });
                    });
                } else if (event.data.customerConfig) {
                    $scope.dd.view.customerConfig.techNote = event.data.customerConfig.techNote;
                    $scope.dd.view.saveCustomerParam();
                } else if (event.data.domain && event.data.sDm) {
                    const APP_SUBDOMAIN = Constants.APP_SUB_DOMAIN;
                    if (event.data.domain === Constants.APP_DOMAIN.planningPos) {
                        if (event.data.sDm === APP_SUBDOMAIN.planning) {
                            $scope.dd.view.pTView.setEditedBookingViewFromModel(BookingData.getById(event.data.itemId));
                            $scope.goToSubDomain(APP_SUBDOMAIN.planning);

                        } else if (event.data.sDm === APP_SUBDOMAIN.pos) {
                            $scope.dd.view.posView.setEditedSaleViewFromModel(SaleData.getById(event.data.itemId));
                            $scope.goToSubDomain(APP_SUBDOMAIN.pos);
                        }
                    } else {
                        $scope.goToDomain(event.data.domain, event.data.sDm);
                    }
                }
            }
        };

        $scope.storageEventListener = function (event) {
            if (event && event.key === "flxLocalState") {
                let userActionRef = JSON.parse(event.newValue);
                if (userActionRef) {
                    UserActionManager.executeUserAction(userActionRef, true);
                }
            }
        };

        const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        if (window[eventMethod]) {
            window[eventMethod]("message", $scope.listenForBackofficeApp);
            window[eventMethod]("storage", $scope.storageEventListener);
        }


        $scope.$on("$destroy", function () {
            window.removeEventListener("message", $scope.listenForBackofficeApp);
            window.removeEventListener("storage", $scope.storageEventListener);

            goToDomainCalledDestroy();
            onNotificationActionDestroy();
            onExternalModelChangedDestroy();
            onChangeUserActionToCancelDestroy();
            onChangeUserActionToRedoDestroy();
            onGlobalLoadingFinishedDestroy();

            Timers.cancel(timers);
        });
    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/planningPos/PlanningPosCtrl.js